import ModalComponent from '../../../components/ModalComponent';

interface Props {
  open: boolean
  blockTitle: string
  handleClose: () => void
  handleSave: () => void
}

const Index = (props:Props) => {
  const {
    open, handleClose, handleSave, blockTitle,
  } = props;

  return (
    <ModalComponent
      title="Delete block"
      confirmButtonText="Delete"
      confirmButtonColor="danger"
      onConfirm={handleSave}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
    >
      <p className="mb-0">
        Are you sure you want to delete block &quot;
        {blockTitle}
        &quot;?
      </p>
    </ModalComponent>
  );
};

export default Index;
